// import { yupResolver } from '@hookform/resolvers/yup';
// import {
//   Alert,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import { FaCalendarAlt, FaCheckCircle, FaComment, FaFileAlt, FaUndo, FaUser } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { FeedbackComplaint } from 'slices/NdisSlices/carporateServices/feedbackAndManagementListSlice';
// import {
//   clearComplaintAndFeedbackState,
//   FeedbackComplaintsFormData,
//   submitComplaintAndFeedback
// } from 'slices/NdisSlices/reportAllForms/complaintAndFeedbackSlice';
// import * as yup from 'yup';

// // Validation schemas
// const actualDataSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_feedback: yup.string().required('Date of feedback/complaint is required'),
//     feedback_provider_name: yup.string().optional().default(''),
//     contact_info: yup.string().optional().default(''),
//     type_of_feedback: yup.string().required('Type of feedback is required'),
//     description: yup.string().required('Description is required'),
//     action_taken: yup.string().optional().default(''),
//     resolved: yup.boolean().optional().default(undefined),
//     created_by: yup.string().optional().default(''),
//     created_on: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date_of_feedback: yup.string().optional().default(''),
//     feedback_provider_name: yup.string().optional().default(''),
//     contact_info: yup.string().optional().default(''),
//     type_of_feedback: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     action_taken: yup.string().required('Action taken is required'),
//     resolved: yup.boolean().required('Please specify if resolved'),
//     created_by: yup.string().optional().default(''),
//     created_on: yup.string().optional().default('')
//   })
//   .required();

// interface FeedbackAndComplaintsFormProps {
//   initialData?: FeedbackComplaint;
//   onClose?: () => void;
// }

// const FeedbackAndComplaintsForm: React.FC<FeedbackAndComplaintsFormProps> = ({
//   initialData,
//   onClose
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.complaintAndFeedback);
//   const navigate = useNavigate();
//   const location = useLocation();

// console.log('initialData', initialData);

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'feedbacks';
//   const feedbackId = initialData?.id || undefined;

//   // Determine which form section to show based on route
//   const isFeedbackComplaintsRoute = location.pathname === '/feedback-complaints';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';

//   // Check if Follow-Up form is already filled
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   useEffect(() => {
//     if (isFollowUpRoute && initialData) {
//       const isFilled = [
//         initialData.action_taken,
//         initialData.resolved !== undefined && initialData.resolved !== null
//       ].some((field) => field !== undefined && field !== null && field !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isFollowUpRoute]);

//   // Use separate useForm hooks for each route
//   const actualDataForm = useForm<FeedbackComplaintsFormData>({
//     resolver: yupResolver(actualDataSchema) as any, // Type assertion to bypass strict type checking
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_feedback: initialData?.date_of_feedback || '',
//       feedback_provider_name: initialData?.feedback_provider_name || '',
//       contact_info: initialData?.contact_info || '',
//       type_of_feedback: initialData?.type_of_feedback || '',
//       description: initialData?.description || '',
//       action_taken: '',
//       resolved: undefined,
//       created_by: initialData?.created_by || '',
//       created_on: initialData?.created_at || ''
//     }
//   });

//   const followUpForm = useForm<FeedbackComplaintsFormData>({
//     resolver: yupResolver(followUpSchema) as any, // Type assertion to bypass strict type checking
//     defaultValues: {
//       id: initialData?.id || '',
//       date_of_feedback: initialData?.date_of_feedback || '',
//       feedback_provider_name: initialData?.feedback_provider_name || '',
//       contact_info: initialData?.contact_info || '',
//       type_of_feedback: initialData?.type_of_feedback || '',
//       description: initialData?.description || '',
//       action_taken: initialData?.action_taken || '',
//       resolved: initialData?.resolved ?? undefined,
//       created_by: initialData?.created_by || '',
//       created_on: initialData?.created_at || ''
//     }
//   });

//   const onSubmitActualData = (data: FeedbackComplaintsFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';
//     const created_on = new Date().toISOString();

//     const payload: FeedbackComplaintsFormData = {
//       date_of_feedback: data.date_of_feedback,
//       feedback_provider_name: data.feedback_provider_name,
//       contact_info: data.contact_info,
//       type_of_feedback: data.type_of_feedback,
//       description: data.description,
//       created_by: client_email,
//       created_on
//     };

//     dispatch(submitComplaintAndFeedback(payload))
//       .unwrap()
//       .then(() => {
//         actualDataForm.reset();
//         setTimeout(() => dispatch(clearComplaintAndFeedbackState()), 5000);
//       });
//   };

//   const onSubmitFollowUp = (data: FeedbackComplaintsFormData) => {
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';
//     const created_on = new Date().toISOString();

//     const payload: FeedbackComplaintsFormData = {
//       id: feedbackId,
//       date_of_feedback: initialData?.date_of_feedback || data.date_of_feedback,
//       feedback_provider_name: initialData?.feedback_provider_name || data.feedback_provider_name,
//       contact_info: initialData?.contact_info || data.contact_info,
//       type_of_feedback: initialData?.type_of_feedback || data.type_of_feedback,
//       description: initialData?.description || data.description,
//       action_taken: data.action_taken,
//       resolved: data.resolved,
//       created_by: client_email,
//       created_on
//     };

//     dispatch(submitComplaintAndFeedback(payload))
//       .unwrap()
//       .then(() => {
//         followUpForm.reset();
//         setTimeout(() => dispatch(clearComplaintAndFeedbackState()), 5000);
//         if (onClose) {
//           onClose();
//         }
//       });
//   };

//   const handleResetActualData = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     actualDataForm.reset();
//     dispatch(clearComplaintAndFeedbackState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     dispatch(clearComplaintAndFeedbackState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.primary.dark
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isFeedbackComplaintsRoute
//                 ? 'Feedback and Complaints Form'
//                 : 'Follow-Up Actions Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isFeedbackComplaintsRoute
//               ? 'For client or stakeholder feedback and complaints'
//               : 'For follow-up actions on feedback and complaints'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearComplaintAndFeedbackState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearComplaintAndFeedbackState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {/* {isFollowUpRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This follow-up form has already been filled.
//           </Alert>
//         )} */}

//         {isFeedbackComplaintsRoute && (
//           <form onSubmit={actualDataForm.handleSubmit(onSubmitActualData)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_of_feedback"
//                     control={actualDataForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Feedback/Complaint"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!actualDataForm.formState.errors.date_of_feedback}
//                         helperText={
//                           actualDataForm.formState.errors.date_of_feedback?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="feedback_provider_name"
//                     control={actualDataForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Feedback Provider’s Name (Optional)"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!actualDataForm.formState.errors.feedback_provider_name}
//                         helperText={
//                           actualDataForm.formState.errors.feedback_provider_name?.message as string
//                         }
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="contact_info"
//                     control={actualDataForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Contact Information (Optional)"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!actualDataForm.formState.errors.contact_info}
//                         helperText={actualDataForm.formState.errors.contact_info?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Feedback/Complaint Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaComment
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Feedback/Complaint Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Type of Feedback
//                     </Typography>
//                     <Controller
//                       name="type_of_feedback"
//                       control={actualDataForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2,
//                             flexWrap: 'wrap'
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Positive"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Positive
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Complaint"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Complaint
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Suggestion"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Suggestion
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {actualDataForm.formState.errors.type_of_feedback && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {actualDataForm.formState.errors.type_of_feedback?.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={actualDataForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!actualDataForm.formState.errors.description}
//                         helperText={actualDataForm.formState.errors.description?.message as string}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetActualData}
//                 disabled={!actualDataForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Feedback'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="action_taken"
//                     control={followUpForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Action Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!followUpForm.formState.errors.action_taken}
//                         helperText={followUpForm.formState.errors.action_taken?.message as string}
//                         //
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Resolved?
//                     </Typography>
//                     <Controller
//                       name="resolved"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           value={field.value === undefined ? '' : field.value ? 'Yes' : 'No'}
//                           onChange={(e) => field.onChange(e.target.value === 'Yes')}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.resolved && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.resolved?.message as string}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !feedbackId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default FeedbackAndComplaintsForm;

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Autocomplete
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useState } from 'react'; // Added useState
import { Controller, useForm } from 'react-hook-form';
import { FaCalendarAlt, FaCheckCircle, FaComment, FaFileAlt, FaUndo, FaUser } from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchStaffByRoles } from 'slices/NdisSlices/calenderEvents/CalenderEventsSlice';

import { FeedbackComplaint } from 'slices/NdisSlices/carporateServices/feedbackAndManagementListSlice';
import {
  clearComplaintAndFeedbackState,
  FeedbackComplaintsFormData,
  submitComplaintAndFeedback
} from 'slices/NdisSlices/reportAllForms/complaintAndFeedbackSlice';
import * as yup from 'yup';

// Type definitions for staff members
interface StaffMember {
  id: string;
  name: string;
  email: string;
  ndis_role: string;
  Client: string;
  avartar: string;
}

// Type definition for calendarEvents state (to fix TS2339)
interface CalendarStateProps {
  staffList: { 'Support worker': StaffMember[]; Manager: StaffMember[] } | null;
  loading: boolean;
  error: string | null;
  // Add other fields as needed
}

// Update type definitions
interface ExtendedFeedbackComplaint extends FeedbackComplaint {
  support_worker?: string;
  manager?: string;
}

interface ExtendedFeedbackComplaintsFormData extends FeedbackComplaintsFormData {
  support_worker?: string;
  manager?: string;
}

// Validation schemas
const actualDataSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_feedback: yup.string().required('Date of feedback/complaint is required'),
    feedback_provider_name: yup.string().required('Feedback provider is required'),
    contact_info: yup.string().optional().default(''),
    type_of_feedback: yup.string().required('Type of feedback is required'),
    description: yup.string().required('Description is required'),
    support_worker: yup.string().optional().default(''),
    manager: yup.string().optional().default(''),
    action_taken: yup.string().optional().default(''),
    resolved: yup.boolean().optional().default(undefined),
    created_by: yup.string().optional().default(''),
    created_on: yup.string().optional().default('')
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date_of_feedback: yup.string().optional().default(''),
    feedback_provider_name: yup.string().optional().default(''),
    contact_info: yup.string().optional().default(''),
    type_of_feedback: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    support_worker: yup.string().optional().default(''),
    manager: yup.string().optional().default(''),
    action_taken: yup.string().required('Action taken is required'),
    resolved: yup.boolean().required('Please specify if resolved'),
    created_by: yup.string().optional().default(''),
    created_on: yup.string().optional().default('')
  })
  .required();

interface FeedbackAndComplaintsFormProps {
  initialData?: ExtendedFeedbackComplaint;
  onClose?: () => void;
}

const FeedbackAndComplaintsForm: React.FC<FeedbackAndComplaintsFormProps> = ({
  initialData,
  onClose
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.complaintAndFeedback);
  const navigate = useNavigate();
  const location = useLocation();

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
  };
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
    projectId?: string;
    projectName?: string;
  };
  const servicesState = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
    selectedServiceTitle?: string;
    selectedServiceId?: string;
  };
  const userDetails = JSON.parse(localStorage.getItem('user-details') || '{}') as {
    name?: string;
    email?: string;
    role?: { role_id: string; label: string }[];
    groups?: string[];
  };

  // Clients list
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };

  const clientsList = useMemo(
    () =>
      participantsList.participants_list.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name,
          id: index + 1,
          email: participant.email
        })
      ),
    [participantsList.participants_list]
  );

  // Support workers and managers from calendarEvents
  const staffList = useTypedSelector((state: RootState) => state.calendarEvents.staffList || {});
  const supportWorkers = useTypedSelector(
    (state: RootState) => state.calendarEvents.staffList?.['Support worker'] || []
  ) as StaffMember[];
  const officeSupport = useTypedSelector(
    (state: RootState) => state.calendarEvents.staffList?.Manager || []
  ) as StaffMember[];
  const staffLoading = useTypedSelector((state: RootState) => state.calendarEvents.loading);

  // Fetch staff using fetchStaffByRoles
  useEffect(() => {
    if (
      selectedClient?.label &&
      selectedProject?.projectId &&
      servicesState?.selectedServiceTitle &&
      userDetails?.email &&
      userDetails?.role &&
      userDetails.role.length > 0 // Added null check
    ) {
      const approvedUser = userDetails.email.split('@')[0].replace('.', '_');
      const payload = {
        group_id: selectedProject.projectId,
        service_name_id: servicesState.selectedServiceTitle.replace(' ', '_'),
        nested_component_id: 'Staff_List',
        email_loggedIn_userEmail: userDetails.email,
        roles: userDetails.role?.map((r) => r.role_id) || [], // Added fallback for undefined role
        client_name: selectedClient.label?.replace(' ', '_') || '',
        approved_user: approvedUser,
        curr_loggIn_userRoles: userDetails?.name || ''
      };
      dispatch(fetchStaffByRoles(payload));
    }
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'feedbacks';
  const feedbackId = initialData?.id || undefined;

  const isFeedbackComplaintsRoute = location.pathname === '/feedback-complaints';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';

  // Current datetime as default
  const defaultDateTime = new Date().toISOString().split('T')[0];

  const actualDataForm = useForm<ExtendedFeedbackComplaintsFormData>({
    resolver: yupResolver(actualDataSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_feedback: initialData?.date_of_feedback || defaultDateTime,
      feedback_provider_name: initialData?.feedback_provider_name || userDetails?.name || '',
      contact_info: initialData?.contact_info || userDetails?.email || '',
      type_of_feedback: initialData?.type_of_feedback || '',
      description: initialData?.description || '',
      support_worker: initialData?.support_worker || '',
      manager: initialData?.manager || '',
      action_taken: '',
      resolved: undefined,
      created_by: initialData?.created_by || userDetails?.email || '',
      created_on: initialData?.created_at || defaultDateTime
    }
  });

  const followUpForm = useForm<ExtendedFeedbackComplaintsFormData>({
    resolver: yupResolver(followUpSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date_of_feedback: initialData?.date_of_feedback || defaultDateTime,
      feedback_provider_name: initialData?.feedback_provider_name || selectedClient?.label || '',
      contact_info: initialData?.contact_info || selectedClient?.email || '',
      type_of_feedback: initialData?.type_of_feedback || '',
      description: initialData?.description || '',
      support_worker: initialData?.support_worker || '',
      manager: initialData?.manager || '',
      action_taken: initialData?.action_taken || '',
      resolved: initialData?.resolved ?? undefined,
      created_by: initialData?.created_by || userDetails?.email || '',
      created_on: initialData?.created_at || defaultDateTime
    }
  });

  const onSubmitActualData = (data: ExtendedFeedbackComplaintsFormData) => {
    const created_on = new Date().toISOString();
    const payload: ExtendedFeedbackComplaintsFormData = {
      date_of_feedback: data.date_of_feedback,
      feedback_provider_name: data.feedback_provider_name,
      contact_info: data.contact_info,
      type_of_feedback: data.type_of_feedback,
      description: data.description,
      support_worker: data.support_worker,
      manager: data.manager,
      created_by: userDetails?.email || '',
      created_on
    };

    dispatch(submitComplaintAndFeedback(payload))
      .unwrap()
      .then(() => {
        actualDataForm.reset();
        setTimeout(() => dispatch(clearComplaintAndFeedbackState()), 5000);
      });
  };

  const onSubmitFollowUp = (data: ExtendedFeedbackComplaintsFormData) => {
    const created_on = new Date().toISOString();
    const payload: ExtendedFeedbackComplaintsFormData = {
      id: feedbackId,
      date_of_feedback: initialData?.date_of_feedback || data.date_of_feedback,
      feedback_provider_name: initialData?.feedback_provider_name || data.feedback_provider_name,
      contact_info: initialData?.contact_info || data.contact_info,
      type_of_feedback: initialData?.type_of_feedback || data.type_of_feedback,
      description: initialData?.description || data.description,
      support_worker: data.support_worker,
      manager: data.manager,
      action_taken: data.action_taken,
      resolved: data.resolved,
      created_by: userDetails?.email || '',
      created_on
    };

    dispatch(submitComplaintAndFeedback(payload))
      .unwrap()
      .then(() => {
        followUpForm.reset();
        setTimeout(() => dispatch(clearComplaintAndFeedbackState()), 5000);
        if (onClose) {
          onClose();
        }
      });
  };

  const handleResetActualData = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    actualDataForm.reset();
    dispatch(clearComplaintAndFeedbackState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    dispatch(clearComplaintAndFeedbackState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.primary.dark
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isFeedbackComplaintsRoute
                ? 'Feedback and Complaints Form'
                : 'Follow-Up Actions Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isFeedbackComplaintsRoute
              ? 'For client or stakeholder feedback and complaints'
              : 'For follow-up actions on feedback and complaints'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearComplaintAndFeedbackState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearComplaintAndFeedbackState())}
          >
            {error}
          </Alert>
        )}

        {isFeedbackComplaintsRoute && (
          <form onSubmit={actualDataForm.handleSubmit(onSubmitActualData)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="date_of_feedback"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Feedback/Complaint"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!actualDataForm.formState.errors.date_of_feedback}
                        helperText={
                          actualDataForm.formState.errors.date_of_feedback?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="feedback_provider_name"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Feedback Provider’s Name"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!actualDataForm.formState.errors.feedback_provider_name}
                        helperText={
                          actualDataForm.formState.errors.feedback_provider_name?.message as string
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="contact_info"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Contact Information"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!actualDataForm.formState.errors.contact_info}
                        helperText={actualDataForm.formState.errors.contact_info?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={supportWorkers}
                        getOptionLabel={(option) => option.name || ''}
                        value={supportWorkers.find((option) => option.name === field.value) || null}
                        onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                        disabled={staffLoading || supportWorkers.length === 0}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Support Worker (Optional)"
                            margin="normal"
                            error={!!actualDataForm.formState.errors.support_worker}
                            helperText={
                              actualDataForm.formState.errors.support_worker?.message ||
                              (staffLoading
                                ? 'Loading support workers...'
                                : supportWorkers.length === 0
                                ? 'No support workers available'
                                : '')
                            }
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUser size={16} />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <>
                                  {staffLoading && <CircularProgress size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              )
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="manager"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={officeSupport}
                        getOptionLabel={(option) => option.name || ''}
                        value={officeSupport.find((option) => option.name === field.value) || null}
                        onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                        disabled={staffLoading || officeSupport.length === 0}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Manager (Optional)"
                            margin="normal"
                            error={!!actualDataForm.formState.errors.manager}
                            helperText={
                              actualDataForm.formState.errors.manager?.message ||
                              (staffLoading
                                ? 'Loading managers...'
                                : officeSupport.length === 0
                                ? 'No managers available'
                                : '')
                            }
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUser size={16} />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <>
                                  {staffLoading && <CircularProgress size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              )
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Feedback/Complaint Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaComment
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Feedback/Complaint Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Type of Feedback
                    </Typography>
                    <Controller
                      name="type_of_feedback"
                      control={actualDataForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2,
                            flexWrap: 'wrap'
                          }}
                        >
                          <FormControlLabel
                            value="Positive"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Positive
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Complaint"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Complaint
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Suggestion"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Suggestion
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {actualDataForm.formState.errors.type_of_feedback && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {actualDataForm.formState.errors.type_of_feedback?.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={actualDataForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!actualDataForm.formState.errors.description}
                        helperText={actualDataForm.formState.errors.description?.message as string}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetActualData}
                disabled={!actualDataForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Feedback'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="action_taken"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Action Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!followUpForm.formState.errors.action_taken}
                        helperText={followUpForm.formState.errors.action_taken?.message as string}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          value={field.value === undefined ? '' : field.value ? 'Yes' : 'No'}
                          onChange={(e) => field.onChange(e.target.value === 'Yes')}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved?.message as string}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="support_worker"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={supportWorkers}
                        getOptionLabel={(option) => option.name || ''}
                        value={supportWorkers.find((option) => option.name === field.value) || null}
                        onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                        disabled={staffLoading || supportWorkers.length === 0}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Support Worker (Optional)"
                            margin="normal"
                            error={!!followUpForm.formState.errors.support_worker}
                            helperText={
                              followUpForm.formState.errors.support_worker?.message ||
                              (staffLoading
                                ? 'Loading support workers...'
                                : supportWorkers.length === 0
                                ? 'No support workers available'
                                : '')
                            }
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUser size={16} />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <>
                                  {staffLoading && <CircularProgress size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              )
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="manager"
                    control={followUpForm.control}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={officeSupport}
                        getOptionLabel={(option) => option.name || ''}
                        value={officeSupport.find((option) => option.name === field.value) || null}
                        onChange={(_, newValue) => field.onChange(newValue?.name || '')}
                        disabled={staffLoading || officeSupport.length === 0}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Manager (Optional)"
                            margin="normal"
                            error={!!followUpForm.formState.errors.manager}
                            helperText={
                              followUpForm.formState.errors.manager?.message ||
                              (staffLoading
                                ? 'Loading managers...'
                                : officeSupport.length === 0
                                ? 'No managers available'
                                : '')
                            }
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUser size={16} />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <>
                                  {staffLoading && <CircularProgress size={20} />}
                                  {params.InputProps.endAdornment}
                                </>
                              )
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !feedbackId}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default FeedbackAndComplaintsForm;
